import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ModelEmailLoadDocumentsRequest } from '@app/models/emailLoadDocuments.model';
import { ModelDocumentsLoadFlagRequest, ReturnDocumentsLoadFlag } from '@app/models/flagLoadDocuments.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export interface ReturnFileDataMail {
  ok?: boolean,
  message?: string,
  data?: null,
  status?: number
}

export interface ReturnFileDataInfoUser {
  ok?: boolean,
  message?: string,
  data?: ReturnFileData,
  status?: number
}
export interface ReturnFileData {
  radicacion?: number,
  documentoComprador?: number,
  tipoDocComprador?: string,
  nombreComprador?: string,
  emailComprador?: string,
  emailAfiliado?: string
}
@Injectable({
  providedIn: 'root'
})
export class UploadDocumentsService {

  public headers: any;
  public urlBuyerInt: string;
  public coviresourceToken: string;
  public buyerIntToken: string;
  public newCfToken: string;

  constructor(private http: HttpClient) {
    this.urlBuyerInt = `${environment.postgres ? environment.urlApiDev : environment.urlApiNit}/buyerint`;
    this.coviresourceToken = environment.coviresourceApiKey;
    this.buyerIntToken = environment.buyerIntApiKey;
    this.newCfToken = environment.newCoviFacturaApiKey;
  }

  sendDocuments(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(this.coviresourceToken)}`
    });
    const url = environment.postgres ? environment.urlApiPostgres : environment.urlApiNit;

    return this.http.post(`${url}/coviresource/CoviResourceServices/servicios/covifactura/saveImage`, body, { headers });
  }

  sendMails(body: ModelEmailLoadDocumentsRequest): Observable<ReturnFileDataMail> {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(this.newCfToken)}`
    });
    const url = `${environment.urlApiDev}/newcovifactura`;

    return this.http.post<ReturnFileDataMail>(`${url}/CoviFactura/cargueDocumentos/enviarCorreo`, body, { headers });
  }

  sendInfoUser(code): Observable<ReturnFileDataInfoUser> {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(this.buyerIntToken)}`
    });
    const params = new HttpParams().append('radicado', code);

    return this.http.get<ReturnFileDataInfoUser>(`${this.urlBuyerInt}/creditoRadicacion/findByNumeroRadicado?`, { headers, params });
  }

  checkLoad(code): Observable<ReturnFileDataInfoUser> {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(this.buyerIntToken)}`
    });
    const params = new HttpParams().append('radicado', code);

    return this.http.get<ReturnFileDataInfoUser>(`${this.urlBuyerInt}/recursoImagenes/verificarCargaDocumento?`, { headers, params });
  }

  saveDocumentUploadFlag(flagBody: ModelDocumentsLoadFlagRequest): Observable<ReturnDocumentsLoadFlag> {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Basic ${btoa(this.buyerIntToken)}`
    });

    return this.http.post<ReturnDocumentsLoadFlag>(`${this.urlBuyerInt}/cargueDocumentosFlag/guardarFlag`, flagBody, { headers });
  }
}